/* ==========================================================
   ACCORDION DO RODAPÉ
   ========================================================== */
(function () {
  'use strict';

  var COPY = {
    'sobre nosotros': {
      title: 'Sobre Nosotros',
      html: '<p>En <strong>Bella Sirena</strong> creamos trajes de baño pensados para realzar tu belleza y brindarte la máxima comodidad.</p>' +
            '<p>Cada diseño combina elegancia, calidad premium y un toque femenino para que te sientas segura en cada ocasión — desde la playa hasta tu próxima escapada.</p>'
    },
    'contacto': {
      title: 'Contacto',
      html: '<p><strong>Email:</strong> apoyo@bellasirena.shop</p>' +
            '<p><strong>WhatsApp:</strong> 00 0000 0000</p>' +
            '<p><strong>Horario de atención:</strong> Lunes a Viernes, 9:00 a 18:00 hrs</p>' +
            '<p>Responderemos tu mensaje en un máximo de 24 horas hábiles.</p>'
    },
    'faq': {
      title: 'Preguntas Frecuentes',
      html: '<p><strong>¿Cuánto tarda mi envío?</strong><br>Entre 8 y 15 días hábiles a todo México.</p>' +
            '<p><strong>¿Puedo cambiar mi producto?</strong><br>Sí, tienes 30 días desde la entrega para solicitar cambio o devolución.</p>' +
            '<p><strong>¿Cómo elijo mi talla?</strong><br>Consulta nuestra guía de tallas en la página de cada producto.</p>' +
            '<p><strong>¿Qué formas de pago aceptan?</strong><br>Tarjetas, Mercado Pago, OXXO y hasta 12 meses sin intereses.</p>'
    },
    'blog': {
      title: 'Blog',
      html: '<p>Próximamente: tips de moda playera, cuidados para tu traje de baño y todas nuestras novedades.</p>' +
            '<p>Síguenos en redes para no perderte nada.</p>'
    },
    'envios': {
      title: 'Envíos',
      html: '<p><strong>Envío express a todo México</strong> en 8 a 15 días hábiles.</p>' +
            '<p>Tu pedido se prepara en un plazo de 24 a 48 horas hábiles después de confirmado el pago.</p>' +
            '<p>Recibirás un código de rastreo por email para seguir tu envío en todo momento.</p>'
    },
    'cambios y devoluciones': {
      title: 'Cambios y Devoluciones',
      html: '<p>Tienes <strong>30 días</strong> a partir de la recepción de tu pedido para solicitar un cambio o devolución sin costo adicional.</p>' +
            '<p>La prenda debe estar sin uso, con sus etiquetas originales y en su empaque.</p>' +
            '<p>Para iniciar el proceso, escríbenos a <strong>apoyo@bellasirena.shop</strong> indicando tu número de pedido.</p>'
    },
    'formas de pago': {
      title: 'Formas de Pago',
      html: '<p>Procesamos los pagos de forma segura a través de <strong>AppMax</strong>, aceptando:</p>' +
            '<ul style="margin:8px 0 8px 18px;padding:0;">' +
              '<li>Tarjetas de crédito y débito — Visa, Mastercard, American Express</li>' +
              '<li>Mercado Pago</li>' +
              '<li>OXXO (pago en efectivo)</li>' +
              '<li>Transferencia bancaria (SPEI)</li>' +
              '<li>Hasta <strong>12 meses sin intereses (MSI)</strong> con tarjetas participantes</li>' +
            '</ul>' +
            '<p>Todos los pagos están protegidos con encriptación SSL.</p>'
    },
    'politica de privacidad': {
      title: 'Política de Privacidad',
      html: '<p>En Bella Sirena respetamos tu privacidad. Tus datos personales son utilizados únicamente para procesar tu compra, enviarte información sobre tu pedido y mejorar tu experiencia de compra.</p>' +
            '<p>No compartimos tu información con terceros, salvo con los proveedores logísticos necesarios para entregar tu pedido.</p>' +
            '<p>Puedes solicitar la eliminación de tus datos en cualquier momento escribiéndonos a <strong>apoyo@bellasirena.shop</strong>.</p>'
    },
    'terminos y condiciones': {
      title: 'Términos y Condiciones',
      html: '<p>Al realizar una compra en Bella Sirena, aceptas nuestros términos de uso.</p>' +
            '<p>Los precios están expresados en pesos mexicanos (MXN) e incluyen impuestos cuando aplica. Nos reservamos el derecho de modificar precios y productos en cualquier momento.</p>' +
            '<p>Para conocer todos los detalles sobre garantías, responsabilidades y resolución de conflictos, contacta a nuestro equipo en <strong>apoyo@bellasirena.shop</strong>.</p>'
    }
  };

  function normalize(s) {
    return (s || '').toString()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, '')
      .trim()
      .replace(/\s+/g, ' ');
  }

  function getCopy(linkText) {
    var key = normalize(linkText);
    return COPY[key] || null;
  }

  function ensurePanel() {
    var panel = document.getElementById('bs-footer-info-panel');
    if (panel) return panel;
    var footer = document.querySelector('.bs-footer') || document.querySelector('footer');
    if (!footer) return null;
    var grid = footer.querySelector('.bs-footer-grid') || footer;
    panel = document.createElement('div');
    panel.id = 'bs-footer-info-panel';
    panel.className = 'bs-footer-info-panel';
    panel.setAttribute('hidden', '');
    panel.innerHTML =
      '<div class="bs-footer-info-inner">' +
        '<button type="button" class="bs-footer-info-close" aria-label="Cerrar">×</button>' +
        '<h4 class="bs-footer-info-title"></h4>' +
        '<div class="bs-footer-info-body"></div>' +
      '</div>';
    if (grid.parentNode) grid.parentNode.insertBefore(panel, grid.nextSibling);
    panel.querySelector('.bs-footer-info-close').addEventListener('click', hidePanel);
    return panel;
  }

  function showPanel(copy) {
    var panel = ensurePanel();
    if (!panel) return;
    panel.querySelector('.bs-footer-info-title').textContent = copy.title;
    panel.querySelector('.bs-footer-info-body').innerHTML = copy.html;
    panel.removeAttribute('hidden');
    void panel.offsetHeight;
    panel.classList.add('is-open');
    panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function hidePanel() {
    var panel = document.getElementById('bs-footer-info-panel');
    if (!panel) return;
    panel.classList.remove('is-open');
    setTimeout(function () { panel.setAttribute('hidden', ''); }, 300);
  }

  function attachHandlers() {
    var footer = document.querySelector('.bs-footer') || document.querySelector('footer');
    if (!footer) return;
    var links = footer.querySelectorAll('a');
    links.forEach(function (link) {
      if (link.dataset.cfInfoBound === '1') return;
      var copy = getCopy(link.textContent);
      if (!copy) return;
      link.dataset.cfInfoBound = '1';
      link.classList.add('bs-footer-info-link');
      link.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var panel = document.getElementById('bs-footer-info-panel');
        if (panel && panel.classList.contains('is-open')) {
          var currentTitle = panel.querySelector('.bs-footer-info-title').textContent;
          if (currentTitle === copy.title) { hidePanel(); return; }
        }
        showPanel(copy);
      });
    });
  }

  function run() { try { attachHandlers(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  [400, 1200, 2500].forEach(function (ms) { setTimeout(run, ms); });
  var observer = new MutationObserver(run);
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
